import { ContactInfoType } from 'interfaces';

const CONTACT_INFO: ContactInfoType[] = [
  { TYPE: 'Web', VALUE: 'https://kli2m-cv.netlify.app', PREFIX: ' ' },
  { TYPE: 'Phone', VALUE: '+375297664647', PREFIX: 'tel:' },
  { TYPE: 'Mail', VALUE: 'kli2m@tut.by', PREFIX: 'mailto:' },
];

export default CONTACT_INFO;
